const sendManagerRequest = {
  sendRequest: 'Отправить запрос',
  personalManagerRequest: 'Запрос на персонального менеджера',
  pleaseFillYourProfile: 'Пожалуйста, заполните свой профиль и оставьте какие-либо контактные данные для лучшей связи.',
  myContact: 'Мой контакт',
  messengerId: 'Ваш идентификатор мессенджера',
  messenger: 'Мессенджер',
  requestForPersonalManager: 'Запрос на назначение персонального менеджера отправлен. Ваш новый персональный менеджер вскоре свяжется с вами.',
};

export default sendManagerRequest;
